export const SET_SELF_SERVICE_ERROR_EVENT_ID = 'SET_SELF_SERVICE_ERROR_EVENT_ID';